/**
 * @desc test
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(body: defs.mail.MailMessageEntity, options?: any) {
  return updateResponse(
    http(URL + `/mail/mailAccount/test1`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
